// src/core/routes/PrivateRouteClient.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const PrivateRouteClient = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/client-login" />;
  }

  try {
    const decoded = jwtDecode(token);
    // Vérifie l'expiration du JWT (en ms)
    if (decoded?.exp && decoded.exp * 1000 < Date.now()) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      return <Navigate to="/client-login" />;
    }
    return children;
  } catch (err) {
    console.error("❌ Erreur décodage JWT (client) :", err?.message || err);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    return <Navigate to="/client-login" />;
  }
};

export default PrivateRouteClient;
